import Cookies from 'js-cookie'

const TokenKey = 'token'
const TenantIdKey = 'tenantId'
const UserInfoKey = 'sysUser'
const permissionKey = 'permission'

// Token相关方法
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 租户ID相关方法
export function getTenantId() {
  return Cookies.get(TenantIdKey)
}

export function setTenantId(tenantId) {
  return Cookies.set(TenantIdKey, tenantId)
}

export function removeTenantId() {
  return Cookies.remove(TenantIdKey)
}

//权限相关方法

/**
 * 权限缓存的有效期（毫秒）。默认 30 分钟。
 *
 * ⚠️ 为什么需要过期（老辛 2026-10-10踩坑）：
 * 原实现是「有缓存就一直用」，导致**后台改了权限（如新增菜单）后，
 * 已登录用户永远看不到**，只能手动清 localStorage 或重新登录，
 * 非常难排查。现在超过有效期就重新拉取。
 * 30 分钟是个折中：既能较快反映权限变更，又不至于每次进页面都打接口。
 */
const PERMISSION_TTL = 30 * 60 * 1000;

/** 缓存时间戳的 key 后缀 */
const TS_SUFFIX = '_ts';

export function getPermission(userId) {
try {
    if (!userId) return null;

  const actualKey = `permission_${userId}`;
    const tsKey = actualKey + TS_SUFFIX;
  const permission = localStorage.getItem(actualKey);

    if (permission && typeof permission === 'string') {
      // 校验是否过期：无时间戳（旧缓存）视为过期，强制刷新一次
      const ts = Number(localStorage.getItem(tsKey) || 0);
      if (!ts || Date.now() - ts > PERMISSION_TTL) {
   console.info('[auth] 权限缓存已过期，将重新拉取, userId=', userId);
        removePermission(userId);
        return null;
    }
      return JSON.parse(permission);
    }
    return null;
  } catch (error) {
    console.error('解析权限缓存失败，将清除无效缓存:', error);
    // 清除无效的缓存数据
    removePermission(userId);
    return null;
  }
}

export function setPermission(permission, userId) {
  try {
    if (!userId || !permission) return null;
    
    const actualKey = `permission_${userId}`;
    // 只过滤掉禁用状态的权限，保留所有启用的权限类型
    const filteredPermission = Object.values(permission)
      .filter(item => item.status === 1)
      .reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    
  // 同时记录写入时间，供 getPermission 校验是否过期
    localStorage.setItem(actualKey, JSON.stringify(filteredPermission));
    localStorage.setItem(actualKey + TS_SUFFIX, String(Date.now()));
  } catch (error) {
    console.error('存储权限数据失败:', error);
    return null;
  }
}

export function removePermission(userId) {
  if (!userId) return null;
  const actualKey = `permission_${userId}`;
  localStorage.removeItem(actualKey + TS_SUFFIX);
  return localStorage.removeItem(actualKey);
}

// 清除旧用户的权限缓存
export function clearOldUserPermission(oldUserId, newUserId) {
  if (oldUserId && oldUserId !== newUserId) {
    removePermission(oldUserId);
  }
}

// 清除所有权限缓存
export function clearAllPermissions() {
  // 遍历localStorage，清除所有以permission_开头的缓存
  for (let key in localStorage) {
    if (key.startsWith('permission_')) {
      localStorage.removeItem(key);
    }
  }
  // 也清除旧的permission缓存
  localStorage.removeItem(permissionKey);
}


// 用户信息相关方法
export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}


// 新增：解析 Token 有效期
export const isTokenExpired = () => {
  const token = getToken()
  if (!token) return true // 无 Token 视为过期

  try {
    // 解析 JWT 的 payload 部分（Base64 解码）
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const payload = JSON.parse(decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    ))

    // JWT 过期时间（exp 字段，单位：秒）
    const expireTime = payload.exp * 1000 // 转毫秒
    const currentTime = Date.now()

    // 提前 30 秒判定为过期（避免网络延迟）
    return currentTime > expireTime - 30000
  } catch (error) {
    console.error('Token 解析失败：', error)
    return true // 解析失败视为过期
  }
}

// 退出登录
export function logout() {
  // 获取当前用户信息
  const userInfo = getUserInfo();
  // 清除当前用户的权限缓存
  if (userInfo && userInfo.id) {
    removePermission(userInfo.id);
  } else {
    // 如果没有用户ID，清除所有权限缓存
    clearAllPermissions();
  }
  removeToken()
  removeTenantId()
  removeUserInfo()
}
